// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        require: {
            cylindo: {
                url: '//viewer.cylindo.com/v4/viewer.min.js', //'//viewer.cylindo.com/3.x/v3.3.1/viewer.min.js',
                fallback: '//viewer.cylindo.com/v4/viewer.min.js', //'//viewer.cylindo.com/3.x/v3.3.1/viewer.min.js',
                callback: null
            },
            vimeo: {
                url: '//player.vimeo.com/api/player.js',
                fallback: '//player.vimeo.com/api/player.js',
                callback: null
            },
            maxmind: {
                url: '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js',
                fallback: '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js',
                callback: null
            },
            jQueryValidateMessages: {
                lang: 'en',
                url: '//cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.0/localization/messages_{0}.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.validate.messages_{0}.js',
                callback: function () {
                    if ( e4.settings.forms.validate.messages[ e4.settings.require.jQueryValidateMessages.lang ] !== undefined ) {
                        jQuery.extend( jQuery.validator.messages, e4.settings.forms.validate.messages[ e4.settings.require.jQueryValidateMessages.lang ] );
                    } else {
                        jQuery.extend(jQuery.validator.messages, {
                            maxlength: jQuery.validator.format("Text is limited to a maximum of {0} characters."),
                        });
                    }
                    jQuery.validator.addMethod( 'localenumber', function ( value, domNode ) {
                        var regExpLocaleNumber = new RegExp( '^(?:-?\\d+|-?\\d{1,3}(?:\\' + e4.settings.separatorInteger + '\\d{3})+)?(?:\\' + e4.settings.separatorDecimal + '\\d+)?$' );
                        return this.optional( domNode ) || regExpLocaleNumber.test( value );
                    }, jQuery.validator.messages.number );
                    jQuery.validator.addMethod("requiredEmailAll", function(value, element) {
                        var strInputName = jQuery(element).attr('Name');
                        var emptyInputs = jQuery('input[name="'+strInputName+'"]').filter(function ( index, element ) {
                            var isInvalid = jQuery(element).val().length === 0;
                            var isInvalidEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( jQuery(element).val() ) === false;
                            return isInvalid || isInvalidEmail;
                        });
                        if(emptyInputs.length > 0){
                            jQuery('.js-e-download-cart-email-warning').removeClass('d-none');
                        } else {
                            jQuery('.js-e-download-cart-email-warning').addClass('d-none');
                        }
                        return emptyInputs.length === 0;
                    }, null );
                    jQuery.validator.methods.min = function ( value, element, param ) {
                        return this.optional( element ) || e4.util.formatStringToJavascriptNumber( value ) >= param;
                    };
                    jQuery.validator.methods.max = function ( value, element, param ) {
                        return this.optional( element ) || e4.util.formatStringToJavascriptNumber( value ) <= param;
                    };
                }
            }
        },
        ecom: {
            filters: {
                cleanUrl: true
            },
            product: {
                url: '/system/data/product'
            },
            myorders: {
                url: '/system/data/orders'
            },
            accountsum: {
                url: '/system/data/ordersum'
            }
        },
        scrollToAnchor: {
            backToTop: {
                revealOffset: 0
            }
        },
        search: {
            result: {
                pages: {
                    show: false
                }
            }
        },
        dealersearch: {
            map: {
                styles: [
                    {
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#f5f5f5'
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#696969"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5" 
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#d3d3d3' 
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'stylers': [
                            {
                                'color': '#808080'
                            },
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'geometry.stroke',
                        'stylers': [ 
                            {
                                'visibility': 'on'
                            },
                            {
                                'color': '#b3b3b3'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#fff'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.local',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'visibility': 'on'
                            },
                            {
                                'color': '#fff'
                            },
                            {
                                'weight': 1.8
                            }
                        ]
                    },
                    {
                        'featureType': 'road.local',
                        'elementType': 'geometry.stroke',
                        'stylers': [
                            {
                                'color': '#d7d7d7'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'visibility': 'on'
                            },
                            {
                                'color': '#ebebeb'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#a7a7a7'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#fff'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#fff'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'visibility': 'on'
                            },
                            {
                                'color': '#efefef'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#696969'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'visibility': 'on'
                            },
                            {
                                'color': '#737373'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'labels',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'geometry.stroke',
                        'stylers': [
                            {
                                'color': '#d6d6d6'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#ffffff'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#dadada'
                            }
                        ]
                    }
                ]
            },
            marker: {
                iconUrl: '/files/templates/designs/innovationliving/_assets/img/googlemaps/',
                iconFileName: {
                    Premium: 'marker-red.png',
                    Online: 'marker-black.png',
                    Online_Premium: 'marker-red.png',
                    Retail: 'marker-black.png',
                    Online_Retail: 'marker-black.png'
                },
                iconFileNameDefault: 'marker-black.png'
            },
            clusterer: {
                imagePath: '/files/templates/designs/innovationliving/_assets/img/googlemaps/',
                imageExtension: 'png'
            }
        }
    } );
}() );
